import React, { useState } from 'react';
import './style.scss';
import Button from '../../../../controls/button';
import useInitFight from '../../../../../contexts/initFight';
import { API_FightNft } from 'shared';
import clsx from 'clsx';

interface Props {
  nft: API_FightNft;
  className?: string;
}

const FightResultsControls = ({ nft, className }: Props) => {
  const [buttonLoading, setButtonLoading] = useState(false);
  const { openPickDialog, goHome } = useInitFight();

  return (
    <div className={clsx('fight-results-controls', className)}>
      <Button
        loading={buttonLoading}
        onClick={() => {
          setButtonLoading(true);
          openPickDialog(nft, () => setButtonLoading(false));
        }}
        className='fight'
      >
        Fight More
      </Button>
      <Button color='secondary' onClick={goHome} className='home-pc'>
        Go Home
      </Button>
      <Button
        color='default'
        variant='outlined'
        onClick={goHome}
        className='home-mobile'
      >
        Go Home
      </Button>
    </div>
  );
};

export default FightResultsControls;
